export const semanticColors = [
  'red',
  'orange',
  'pink',
  'blue',
  'olive',
  'violet',
  'teal',
  'purple',
  'brown',
  'grey',
  'black'
]

export const _COLORS = [
  '#ABDEE6', '#CBAACB', '#FFCCB6', '#CCE2CB',
  '#8FCACA', '#ECD5E3', '#F6EAC2', '#FFDBCC',
  '#B6CFB6', '#D4F0F0', '#FFFFB5', '#F3B0C3',
  '#C6DBDA'
]

export const _MIXEDCOLORS = [
  '#FF5533', '#FF850A', '#FFDD00', '#54CD13',
  '#50E3C2', '#4EA995', '#3286B9', '#1F6BC1',
  '#BE0AFF', '#6D29F5'
]

export const _MONOCHROMATICCOLORS = [
  '#1A2247', '#232C58', '#1B4560', '#22577A',
  '#2D7D90', '#5998A7', '#08D6A1', '#20BDA3',
  '#6DE9C6', '#A3F3B2', '#89E4C9', '#C7F9CC'
]

export const _PHASECOLORS = [
  '#1663DD', '#FF6446', '#FFBB00', '#7C3DF6',
  '#F53D6E', '#08D6A1', '#26E5FF', '#F13333'
]
